import type { Location } from 'react-router-dom';

export enum RoutineSubmitSource {
  AssetCard = 'asset-card',
  RoutinesList = 'routines-list',
}

export const ALL_ACTIVITIES_QUERY_VALUE = 'activities-all';
export const ALL_ACTIVITIES_QUERY_KEY = `from=${ALL_ACTIVITIES_QUERY_VALUE}`;

export const assetPaths = {
  root: 'assets',
};

/**
 * The asset activity detail URL. Singular `activity` — `activities/:issueId` is
 * a legacy alias that only redirects, so hand-writing the plural silently
 * routes somewhere else (GRIPP #3039).
 *
 * @param assetBasePath - Asset-scoped prefix: `/assets/:assetId`, or
 *   `…/asset/:assetId` under the activities, digest and workspace stacks.
 * @param search - Query string including its leading `?`, when there is one.
 */
export const assetActivityPath = (
  assetBasePath: string,
  issueId: string,
  search = ''
) => `${assetBasePath}/activity/${issueId}${search}`;

const ASSET_ROOT_PATH_PATTERN = /^\/assets\/[^/]+\/?$/;
const ACTIVITY_ASSET_ROOT_PATH_PATTERN =
  /^\/activities\/[^/]+\/asset\/[^/]+\/?$/;
const WORKSPACE_ROOT_PATH_PATTERN = /^\/workspaces\/[^/]+\/?$/;

export function isActivityOrEditPage(location: Location<unknown>): boolean {
  return (
    location.pathname.includes('/activity/') ||
    location.pathname.includes('/edit') ||
    location.pathname.includes('/detail') ||
    location.pathname.includes('/routines') ||
    location.pathname.includes('/files')
  );
}

export function isActivitiesParent(location: Location<unknown>): boolean {
  return location.pathname.startsWith('/activities/');
}

// Only base asset panels should hand motion to a newly mounted asset sub-route.
// Sibling sub-routes at the same depth update the right panel in place.
export function shouldUseAssetSubrouteInitialTransition(
  location: Location<unknown>
): boolean {
  return (
    ASSET_ROOT_PATH_PATTERN.test(location.pathname) ||
    ACTIVITY_ASSET_ROOT_PATH_PATTERN.test(location.pathname) ||
    WORKSPACE_ROOT_PATH_PATTERN.test(location.pathname)
  );
}
